module.exports = __webpack_public_path__ + "static/img/study_report_official.ac1a2eee.png";